// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"9cc2144a","787":"91c339e2"}[chunkId] + ".chunk.js";
};